import { useId } from "react";

export const usePrefixedId = (prefix: string) => `${prefix}-${useId()}`;
